import React, { useContext, useEffect, useState } from "react";
import C1 from "../../../src/assets/images/C1.svg";
import C1aimg from "../../../src/assets/images/C1A.svg";
import C2img from "../../../src/assets/images/C2.svg";
import Coimg from "../../../src/assets/images/C0.svg";
import { FilterContext } from "../../context/Filter";
import { axInstBasic } from "../Service/Service";

export const getArnPayload = (parArn, childArn) => {
  const base = {
    ...(childArn ? { childArn } : { parArn }),
  };

  Object.keys(base).forEach((key) => {
    if (Array.isArray(base[key]) && base[key].length === 0) {
      delete base[key];
    }
  });
  return base;
};

export const getCurrentPipeline = async (parArn, childArn) => {
  const values = getArnPayload(parArn, childArn);
  try {
    const res = await axInstBasic.post(
      `${process.env.REACT_APP_API_URL}currentPipeline`,
      values
    );
    // console.log("API response (currentPipeline):", res.data);
    return res?.data?.stages || null;
  } catch (error) {
    console.error("Error fetching currentPipeline:", error);
    throw error;
  }
};

const Currentpipeline = () => {
  const { arn: parArn, childArn } = useContext(FilterContext);
  const [currentPipelineData, setCurrentPipelineData] = useState(null);
  useEffect(() => {
    const currentPipeLineDetails = async () => {
      try {
        const response = await getCurrentPipeline(parArn, childArn);
        // console.log("Response:", response);
        setCurrentPipelineData(response);
      } catch (error) {
        console.error("Error fetching pipeline data:", error);
      }
    };
    if (parArn || childArn) currentPipeLineDetails();
  }, [parArn, childArn]);
  return (
    <div className="flex-col m-2">
      <div className="flex gap-1  ">
        <div className=" w-full ">
          <div className="bg-[#FFE3BA] flex w-full gap-8 border p-2 rounded-md">
            <div>
              <img className=" size-18" src={Coimg} />
            </div>
            <div className="justify-center ">
              <h1 className="text-3xl ">{currentPipelineData?.C0}</h1>
            </div>
          </div>
        </div>

        <div className=" bg-[#D0EBFF] w-full flex p-2 gap-8 border rounded-md">
          <div className="flex ">
            <img className=" size-18" src={C1} alt="" />
          </div>
          <div>
            <h1 className="text-3xl justify-center justify-items-center ">
              {currentPipelineData?.C1}
            </h1>
          </div>
        </div>
      </div>

      <div className="flex gap-1 mt-1">
        <div className=" bg-[#C6FFE7] w-full flex gap-8 p-2 border rounded-md ">
          <div>
            <img className=" size-18" src={C1aimg} />
          </div>
          <div>
            <h1 className="text-3xl text-center items-center ">
              {currentPipelineData?.C1A}
            </h1>
          </div>
        </div>
        <div className="  bg-[#C8FAFF] flex w-full  gap-8 border rounded-md">
          <div className="">
            <img className=" mt-2 size-18" src={C2img} />
          </div>
          <div>
            <h1 className="text-3xl justify-center justify-items-center ">
              {currentPipelineData?.C2}
            </h1>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Currentpipeline;
